import { render, staticRenderFns } from "./ExchangeContent.vue?vue&type=template&id=5cb52e25&scoped=true&"
import script from "./ExchangeContent.vue?vue&type=script&lang=js&"
export * from "./ExchangeContent.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeContent.vue?vue&type=style&index=0&id=5cb52e25&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb52e25",
  null
  
)

export default component.exports